import AddIcon from '@mui/icons-material/Add'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ReadMoreIcon from '@mui/icons-material/ReadMore'
import RemoveIcon from '@mui/icons-material/Remove'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {grey} from '@mui/material/colors'
import {DiscoveryRequestConcept} from 'app/modules/discovery/core/_models'
import {IConceptFE} from 'interfaces/IConceptFE'
import {ISavedSearchFE} from 'interfaces/ISavedSearchFE'
import {useState} from 'react'
import {emInstanceOf} from 'utilities/extensionMethods'
import DraggableConceptItemNotify from '../draggable/DraggableConceptItemNotify'

export default function ShowMoreConceptsNotify({
  search,
  concepts,
  maxCons,
  moreString,
  lessString,
  dialog,
  inheritColor,
  stackVertical,
  currScrollPosition,
  returl,
  size,
  color,
  ignore,
}: {
  search: ISavedSearchFE
  concepts: IConceptFE[] | DiscoveryRequestConcept[]
  maxCons: number
  moreString?: string
  lessString?: string
  emptyCondition?: string
  stackVertical?: boolean
  currScrollPosition?: number
  size?: 'small' | 'regular'
  dialog?: boolean
  inheritColor?: boolean
  returl?: string
  color?: string
  ignore?: boolean
}): React.ReactElement {
  let cons: IConceptFE[] = []
  if (emInstanceOf<DiscoveryRequestConcept>(concepts.length ? concepts[0] : [], 'graph_id')) {
    const x = concepts as unknown as DiscoveryRequestConcept[]
    x?.map((drc) => {
      cons.push({
        id: drc.graph_id,
        name: drc.getName(),
        __weight: drc.weight ?? 1,
        __lock: 'include',
      })
    }) ?? []
  } else {
    cons = concepts as unknown as IConceptFE[]
  }

  const [isCollapse, setIsCollapse] = useState(true)
  const [open, setOpen] = useState<boolean>(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const DialogComponent = () => {
    const subConcepts = cons.slice(0, 10)
    return (
      <>
        {subConcepts}
        <a onClick={handleOpen}>
          {!open && <ReadMoreIcon color={'info'} fontSize='large' sx={{cursor: 'pointer'}} />}
        </a>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <DialogContent>
            <Box>
              <Typography id='modal-modal-title' variant='h6' component='h2'>
                Concepts:
              </Typography>
              <Typography variant='caption'>
                <Stack direction={stackVertical ? 'column' : 'row'} flexWrap={'wrap'}>
                  {cons.map((concept, idx) => {
                    const chipLink = !returl
                      ? `/concepts/detail?externalId=${concept.id}&scrollPosition=${currScrollPosition}`
                      : `/concepts/detail?externalId=${concept.id}&scrollPosition=${currScrollPosition}&retval=${returl}`
                    return (
                      <Box
                        key={idx}
                        sx={{
                          '>:not(style) ~ :not(style)': {
                            marginLeft: 0,
                          },
                        }}
                      >
                        <DraggableConceptItemNotify
                          search={search}
                          item={concept}
                          index={idx}
                          key={concept.name}
                          size={'sm'}
                        />
                      </Box>
                    )
                  })}
                </Stack>
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }

  const ConceptList = () => {
    const conceptsTemp = isCollapse ? cons.slice(0, maxCons) : cons
    return (
      <Typography variant='caption'>
        <Stack direction={stackVertical ? 'column' : 'row'} flexWrap={'wrap'}>
          {conceptsTemp.map((c, idx) => {
            const chipLink = !returl
              ? `/concepts/detail?externalId=${c.id}&scrollPosition=${currScrollPosition}`
              : `/concepts/detail?externalId=${c.id}&scrollPosition=${currScrollPosition}&retval=${returl}`
            return (
              <Box display={'inline-flex'} key={idx}>
                {/* {size && size === 'small' ? (
                  <SmallConceptChip
                    key={idx}
                    concept={c}
                    link={chipLink}
                    color={color}
                    ignore={ignore}
                  />
                ) : (
                  <ConceptChip key={idx} concept={c} link={chipLink} />
                )} */}
                <DraggableConceptItemNotify
                  search={search}
                  item={c}
                  index={idx}
                  key={c.name}
                  size={'sm'}
                />
              </Box>
            )
          })}
        </Stack>
      </Typography>
    )
  }

  return cons && cons.length > maxCons ? (
    <Box component={'span'} color={inheritColor ? 'inherit' : grey[800]} fontSize={'inherit'}>
      {dialog ? (
        <DialogComponent />
      ) : (
        <>
          {ConceptList()}
          <a onClick={() => setIsCollapse((isCollapse) => !isCollapse)}>
            {isCollapse ? (
              <Typography variant={'subtitle1'}>
                <AddIcon color={'info'} fontSize='medium' sx={{cursor: 'pointer'}} /> {moreString}
              </Typography>
            ) : lessString ? (
              <Typography variant={'subtitle1'}>
                <RemoveIcon color={'info'} fontSize='medium' sx={{cursor: 'pointer'}} />{' '}
                {lessString}
              </Typography>
            ) : (
              <ExpandLessIcon color={'info'} fontSize='large' sx={{cursor: 'pointer'}} />
            )}
          </a>
        </>
      )}
    </Box>
  ) : (
    <Box component={'span'} color={inheritColor ? 'inherit' : grey[800]} fontSize={'inherit'}>
      {dialog ? <DialogComponent /> : <>{ConceptList()}</>}
    </Box>
  )
}
